/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * This service enables external control and communication between the "PlanPrintPanelComponent"
 * and other parts of the application after the component's initialization. It also manages the
 * opening and closing of the filter panel as needed and the "quick search" component in top navigation bar.
 */
@Injectable({ providedIn: 'root' })
export class PlanPrintPanelRemoteControlService {
	private _enablePlanPrintSettings$ = new BehaviorSubject<boolean>(false);

	/** emits when the panel is opened or closed, true is open */
	public enablePlanPrintSettings$: Observable<boolean> = this._enablePlanPrintSettings$.asObservable();

	openPrintPlantSettingsControl() {
		this._enablePlanPrintSettings$.next(true);
	}

	closePrintPlantSettingsControl() {
		this._enablePlanPrintSettings$.next(false);
	}

	constructor() {}
}
